import { gql } from '@apollo/client';
import { useMutation } from '@hooks/apollo';

export const CANCEL_REQUISITION_GQL = gql`
mutation CANCEL_REQUISITION_MUTATION ($input: CancelRequisitionMutationInput!) {
  cancelRequisition (input: $input) {
    activeRequisition {
      id
      status
    }
  }
}
`;

export const useCancelRequisitionMutation = (options) => useMutation(
  CANCEL_REQUISITION_GQL,
  options,
);
